import { isMobile } from '../utils/index'
export default {
  address: '台中市太平區立功路210號',
  googleSrc:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.486484306952!2d120.7126543760597!3d24.154665773135093!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346922aa638aea73%3A0xbcf1daf063dcdba2!2zNDEx5Y-w5Lit5biC5aSq5bmz5Y2A56uL5Yqf6LevMjEw6Jmf!5e0!3m2!1szh-TW!2stw!4v1757672283591!5m2!1szh-TW!2stw',
  googleLink: 'https://maps.app.goo.gl/R3FS79zFz14gjEuE9',
  phone: '04-2398-1111',
  fbLink: 'https://www.facebook.com/PC.SMILECASTLE',
  fbMessage: 'https://m.me/PC.SMILECASTLE',
  caseName: '微笑莊園',
  indigatorLength: 10,

  houseInfos: [
    ['投資興建', '麗寶集團 鵬程建設',],
    ['營造公司', '安生營造',],
    ['建築設計', '陳明偉建築師',],
    ['使用執照', '110中都使字第00490號',],
    ['行銷企劃', '海沃創意行銷',],
  ],

  gtmCode: ['N4QBMF9'], // 可放置多個
  recaptcha_site_key_v2: '6LfGUjEaAAAAANYvhZQx5imGm23pRt0V-rOvkpNC',
  recaptcha_site_key: '6Lck-L8UAAAAABxfvNA1NJuBrdl3iLFc3GkudC8s', // recaptcha v3
  recaptcha_user_token: '6Lck-L8UAAAAAIcvenwGDl8_Q1tKbrEYsKuriePa',
  order: {
    title: '預約賞屋',
    // subTitle: '若想了解更多資訊，歡迎填寫表單或來電洽詢，將由專人為您服務，謝謝！
  //  room_type: ['兩房','三房'],//房型
  },
  lixin_logo:true, //false

}